import { dynamicIconImports } from "lucide-react/dynamic";
import { SITE_ICON_INDEX } from "./site-icon-index";

/** Every icon a menu entry can wear: the whole Lucide library (drawn by `SiteIcon`); a menu entry with a name outside this list is refused. */
export const SITE_ICON_NAMES = Object.keys(dynamicIconImports).filter((name) => SITE_ICON_INDEX[name.replaceAll("-", "")]) as [string, ...string[]];
